import { getConsentCookie, getLanguage } from '@client/utils/cookieConsent'
import isServer from './isServer'

const cookieConsentEnabledMap = { br: true, mx: true, uk: false, us: true }
const attributeCategory = 'data-cookiecategory'

const isJsonString = str => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}
export const getInitialCategories = country => {
  const isEnabledByDefault = cookieConsentEnabledMap[country]
  return {
    functional: isEnabledByDefault,
    marketing: isEnabledByDefault,
    analytics: isEnabledByDefault,
    essential: true,
  }
}

const enableScriptTags = cookieCategories => {
  const scripts = document.querySelectorAll('script[type*=plain]')

  scripts.forEach(item => {
    const scriptCategory = item.attributes[attributeCategory]?.value
    if (cookieCategories[scriptCategory]) {
      const script = document.createElement('script')
      const { attributes } = item
      const len = attributes.length

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < len; i++) {
        const attrName = attributes[i].nodeName
        script.setAttribute(
          attrName,
          item[attrName] || item.getAttribute(attrName)
        )
      }
      script.type = 'text/javascript'
      script.textContent = `${item.textContent}`
      document.body.appendChild(script)
    }
    item.remove()
  })
}

export const getCookieConsentCategories = country => {
  const cookie = getConsentCookie()
  const defaultValue = getInitialCategories(country)
  const decodedToken = decodeURIComponent(cookie) || {}
  const isJson = isJsonString(decodedToken)
  const language = getLanguage(country)
  const cookieCategories =
    (isJson && JSON.parse(decodedToken)?.[language]) || defaultValue

  return cookieCategories
}

export const insertScripts = country => {
  if (isServer) {
    return
  }

  const cookieCategories = getCookieConsentCategories(country)
  enableScriptTags(cookieCategories)
}
